// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-editor {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  flex: 1;
}

.sample-editor .sample-controls {
  background: #444;
  border-radius: 3px;
  flex: 0 1 auto;
  align-self: stretch;
}

.sample-editor .waveform {
  flex: 1 1 auto;
  align-self: stretch;
}

.control-group.basenote,
.control-group.finetune,
.control-group.loop {
  flex-direction: row;
  overflow-y: auto;
}

.control-group.basenote input#basenote,
.control-group.finetune input#finetune {
  width: 40px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/sample_editor/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".sample-editor {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  flex-direction: row;\n  flex: 1;\n}\n\n.sample-editor .sample-controls {\n  background: #444;\n  border-radius: 3px;\n  flex: 0 1 auto;\n  align-self: stretch;\n}\n\n.sample-editor .waveform {\n  flex: 1 1 auto;\n  align-self: stretch;\n}\n\n.control-group.basenote,\n.control-group.finetune,\n.control-group.loop {\n  flex-direction: row;\n  overflow-y: auto;\n}\n\n.control-group.basenote input#basenote,\n.control-group.finetune input#finetune {\n  width: 40px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
